import React from "react";
import AppIcon from "./AppIcon";

export default function PageHeader({ icon = "spark", eyebrow, title, subtitle, actions = null }) {
  return (
    <div className="page-header premium-fade-in">
      <div className="page-header-main">
        <div className="page-header-icon-wrap">
          <div className="page-header-icon" aria-hidden="true">
            <AppIcon name={icon} />
          </div>
        </div>
        <div className="page-header-copy">
          {eyebrow ? <div className="page-header-eyebrow">{eyebrow}</div> : null}
          <h2>{title}</h2>
          {subtitle ? <div className="page-header-subtitle">{subtitle}</div> : null}
        </div>
      </div>
      {actions ? <div className="page-header-actions">{actions}</div> : null}
    </div>
  );
}
